import { Goal } from '@/core/interfaces';
import { AuthService } from '@/shared/services';
import { ToolListService } from '@/shared/services/tool-list.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'toolbox-menu',
  templateUrl: './toolbox-menu.component.html',
  styleUrl: './toolbox-menu.component.css',
  standalone: false,
})
export class ToolboxMenuComponent {
  @Input({ required: true }) toolList!: Goal[];

  constructor(
    private toolListService: ToolListService,
    private authService: AuthService,
  ) {}

  toggleShowHideTool(event: Event, tool: Goal) {
    event.stopPropagation();
    const hidden = !tool.hidden;
    this.toolListService.setToolHiddenFlag(tool, hidden);
  }

  hasPermission({ tool_permission }: Goal) {
    return this.authService.hasPermission(tool_permission);
  }
}
